export const emptyFieldError = 'This field needs to be filled in';
export const optionSelectionError = 'An option needs to be selected';
export const questionNotAnsweredError = 'This question needs to be answered';

export function validateTextField(field: string): string {
    return field ? '' : emptyFieldError;
}

export function validateOptionField(field: string): string {
    return field !== '' && field !== 'none' ? '' : optionSelectionError;
}

export function validateNumberField(numberValue: string) {
    return Number.isNaN(Number.parseInt(numberValue))
        ? 'A valid number needs to be entered '
        : '';
}

export function validateTextArea(field: string): string {
    return field.length <= 1000
        ? ''
        : 'A maximum of 1000 characters can be used';
}
